import React from 'react'
import styled from 'styled-components'
import { breakpointFrom, breakpointUpTo } from 'utils/breakpoints'
import { LayoutContentWrapper } from 'components/LayoutContentWrapper/LayoutContentWrapper'
import { ExternalLink } from 'components/ExternalLink/ExternalLink'
import SVG from 'react-inlinesvg'
import ArrowRight from 'assets/icons/arrowRight.svg'
import { GatsbyImage } from 'gatsby-plugin-image'
import { IImage } from '../../../graphql/types'

export type BlogPostProps = {
  img: IImage
  title: string
  description: string
  url: string
}

const Wrapper = styled.div`
  position: relative;
  padding: 0 ${({ theme }) => theme.space[8]};
  display: flex;
  place-items: center;
  height: 720px;

  ${({ theme }) => breakpointUpTo(theme.breakpoints.md)} {
    height: 512px;
    padding: 0 ${({ theme }) => theme.space[7]};
  }
  ${({ theme }) => breakpointUpTo(theme.breakpoints.sm)} {
    height: 320px;
  }
  ${({ theme }) => breakpointFrom(theme.breakpoints.xl)} {
    height: 960px;
  }
`
const ContentWrapper = styled.div`
  padding: ${({ theme }) => theme.space[6]};
  background-color: ${({ theme }) => theme.colors.white};
  width: 564px;
  h2 {
    margin-top: 0;
    margin-bottom: 12px;
    ${({ theme }) => theme.typography.LrgH2}
  }
  p {
    margin: 0;
    ${({ theme }) => theme.typography.LrgBody1}
  }

  ${({ theme }) => breakpointUpTo(theme.breakpoints.md)} {
    width: 428px;
    padding: 48px 36px;
    h2 {
      ${({ theme }) => theme.typography.MedH2}
    }
    p {
      margin: 0;
      ${({ theme }) => theme.typography.MedBody1}
    }
  }
  ${({ theme }) => breakpointUpTo(theme.breakpoints.sm)} {
    display: none;
  }
  ${({ theme }) => breakpointFrom(theme.breakpoints.xl)} {
    width: 792px;
    h2 {
      ${({ theme }) => theme.typography.XLH2}
    }
    p {
      ${({ theme }) => theme.typography.XLBody1}
    }
  }
`
const ContentWrapperSM = styled(LayoutContentWrapper)`
  display: none;

  ${({ theme }) => breakpointUpTo(theme.breakpoints.sm)} {
    display: block;
    margin-top: 24px;
    margin-bottom: 36px;

    h2 {
      ${({ theme }) => theme.typography.SmH3}
      margin-bottom: ${({ theme }) => theme.space[1]}
    }

    p {
      margin: 0 0 ${({ theme }) => theme.space[1]};
      ${({ theme }) => theme.typography.SmBody1}
    }
  }
`
const StyledGatsbyImage = styled(GatsbyImage)`
  z-index: -1;
  left: 0;
  top: 0;
  width: 100%;
  height: 100%;
  &&& {
    position: absolute;
  }
`
export const BlogPost = ({ img, title, description, url }: BlogPostProps) => (
  <>
    <Wrapper>
      <StyledGatsbyImage
        alt={img.alternativeText}
        image={img.image.gatsbyImageData}
      />
      <a href={url} aria-label={title}>
        <ContentWrapper>
          <h2>{title}</h2>
          <p>{description}</p>
        </ContentWrapper>
      </a>
    </Wrapper>
    <ContentWrapperSM>
      <h2>{title}</h2>
      <p>{description}</p>
      <ExternalLink href={url}>
        Read More <SVG src={ArrowRight} />
      </ExternalLink>
    </ContentWrapperSM>
  </>
)
